module.exports = __webpack_public_path__ + "img/aba_darach_yes.150367d7.png";